/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const UserProcessStateDto = {
    None: 'NONE',
    ProcessInitialized: 'PROCESS_INITIALIZED',
    CandidatePersonalDataCollected: 'CANDIDATE_PERSONAL_DATA_COLLECTED',
    QuizInitialized: 'QUIZ_INITIALIZED',
    QuizFinished: 'QUIZ_FINISHED',
    QuizRevisitsExceeded: 'QUIZ_REVISITS_EXCEEDED',
    QuizPointsResultReady: 'QUIZ_POINTS_RESULT_READY',
    QuizExpired: 'QUIZ_EXPIRED',
    CandidateSkillsAssessmentCollected: 'CANDIDATE_SKILLS_ASSESSMENT_COLLECTED'
} as const;

export type UserProcessStateDto = typeof UserProcessStateDto[keyof typeof UserProcessStateDto];



